import { IDataLogin, IUser } from '@core/api-types/user';
import {
    createActionGroup,
    props,
    emptyProps,
    createAction,
} from '@ngrx/store';
import { IAccountRegister } from '../services/auth.service';

export const authActions = createActionGroup({
    source: 'Auth',
    events: {
        getUser: emptyProps(),
        getUserFailure: props<{ error: Error }>(),
        getUserSuccess: props<{ user: IDataLogin }>(),
        login: props<{ username: string; password: string }>(),
        loginFailure: props<{ error: Error }>(),
        loginSuccess: props<{ user: IDataLogin }>(),
        register: props<IAccountRegister>(),
        registerFailure: props<{ error: Error }>(),
        registerSuccess: props<{ user: IDataLogin }>(),
        logout: emptyProps(),
        logoutFailure: props<{ error: Error }>(),
    },
});
